<template>
  <div class="ui grid">
    <div class="row">
      <div class="column">
        <div class="ui top attached tabular menu">
          <a class='active item' data-tab='list-panel'>List</a>
          <a class='item' data-tab='player-panel'>Player</a>
          <a class='item' data-tab='description-panel'>Description</a>
        </div>
        <div data-tab="list-panel" class="ui bottom attached active tab segment">
          <button v-on:click="page -= 1">Before</button>
          <button v-on:click="page += 1">Next</button>
          <div class="ui relaxed divided list">
            <video-list-item v-for="(video, index) in videos" v-bind:video="video" v-on:setVideoItem='setVideoItem'></video-list-item>
          </div>
          <button v-on:click="page -= 1">Before</button>
          <button v-on:click="page += 1">Next</button>
        </div>
        <div data-tab="player-panel" class="ui bottom attached tab segment">
          <video-item v-bind:video="currentVideo"></video-item>
        </div>
        <div id='video-player' v-if='currentVideo.video_id'>
          <iframe v-bind:width="videoPlayerInfo.width" v-bind:height="videoPlayerInfo.height" v-bind:src="'//www.youtube.com/embed/' + currentVideo.video_id" frameborder="0" allowfullscreen="false"></iframe>
          <br />
          <div class="fb-comments" v-bind:data-href="'https://spinoff.cloudhomez.com/' + currentVideo.video_id" data-numposts="5"></div>
        </div>
        <div data-tab="description-panel" class="ui bottom attached tab segment">
          <div class="">Video Description</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import VideoListItem from '../videos/VideoListItem'
  import VideoItem from '../videos/VideoItem'
  import axios from 'axios'

  export default {
    name: 'video-page',
    components: {
      VideoListItem,
      VideoItem
    },
    data() {
      return {
        page: 1,
        videos: [],
        currentVideo: {},
        videoPlayerInfo: {
          page: 1,
          // width: 480,
          // height: 270,
          width: 550,
          height: 310,
          aspectRatio: '16:9',
          keyword: ''
        }
      }
    },
    created: function () {
      this.pagination()
    },
    watch: {
      currentVideo() {

      },
      page(val) {
        this.pagination()
      }
    },
    mounted() {
      window.$('.menu .item').tab()
      this.loadVideos()
    },
    updated() {
    },
    methods: {
      loadVideos() {
        // this.$resource('/v1/videos.json', {});
        // https://test.nimdla.com/api/v1/videos.json
        var self = this
        this.$http.get('/static/jsons/videos/' + self.page + '.json', {
        }).then((response) => {
          this.videos = response.data.data
        })
      },
      setVideoItem(video) {
        this.currentVideo = video
        window.FB.XFBML.parse()
      },
      pagination() {
        var self = this
        axios.get('/static/jsons/videos/' + self.page + '.json').then(function (response) {
          self.videos = response.data.data
        }).catch(function (error) {
          window.console.log(error)
        })
      }
    }
  }
</script>
<style scoped>
#video-player {
  background-color: #ffffff;
  border: 1px solid #000000;
  position: fixed;
  margin-right: 2em;
  margin-top: 4em;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// Video.vue?76c41a0e